/**
 */
export const selectModule = (state) => state.module.log

/**
 */
export const selectCondition = (state) => selectModule(state).condition
